module.exports = "<div class=\"heading type-blue\">\n    <div class=\"icon\">\n      <img [src]=\"src\" height=\"{{height}}\" width=\"{{width}}\">\n    </div>\n    <div class=\"descr\">\n      <strong class=\"title\">{{title}}</strong>\n  </div>\n </div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/card-hdr/card-hdr.component.html
// module id = ../../../../../src/app/brds/widgets/card-hdr/card-hdr.component.html
// module chunks = 10